module.exports = __webpack_public_path__ + "images/device_plus.371350cdda36da099b81c6337f4f5d95.png";